import * as React from 'react';
import type { SVGProps } from 'react';
const ImportIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="21"
    height="20"
    viewBox="0 0 21 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M16.9993 8.74935V5.66602C16.9993 4.26588 16.9993 3.56582 16.7269 3.03104C16.4872 2.56063 16.1047 2.17818 15.6343 1.9385C15.0995 1.66602 14.3995 1.66602 12.9993 1.66602H7.66602C6.26588 1.66602 5.56582 1.66602 5.03104 1.9385C4.56063 2.17818 4.17818 2.56063 3.9385 3.03104C3.66602 3.56582 3.66602 4.26588 3.66602 5.66602V14.3327C3.66602 15.7328 3.66602 16.4329 3.9385 16.9677C4.17818 17.4381 4.56063 17.8205 5.03104 18.0602C5.56582 18.3327 6.26588 18.3327 7.66602 18.3327H10.3327M11.9993 9.16602H6.99935M8.66602 12.4993H6.99935M13.666 5.83268H6.99935M15.3327 17.4993V12.4993M12.8327 14.9993H17.8327"
      stroke="#9099A5"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default ImportIcon;
